import React from 'react'
import * as C from "../componentsM/index";
import { Accordion } from "flowbite-react";

const AdmissionProcess = () => {



    const content = new getContent()


    return (
        <>

            <C.Hero title={"ADMISSION REQUIREMENT"} image={"/hero/14.jpg"} />

            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>


                    <div>

                        <h1 className="text-xl md:text-3xl font-light mb-2">
                            Programme Specific Requirements
                        </h1>

                        <p className='font-semibold'>English is the language of instruction at The International School. All applicants must meet age-appropriate English Language and Literacy, as well as quantitative and analytical skill requirements.</p>

                    </div>


                    <div>

                        <h1 className="text-xl md:text-3xl font-light mb-2">
                            English Language and Literacy Requirements
                        </h1>

                        <p className='font-semibold'>Applicants, regardless of country of origin or citizenship status, must demonstrate competence and literacy in  the English language prior to admission. Competence is expected in all four of the following skills: listening, reading, speaking, and writing.</p>

                    </div>




                    <div>

                        <Accordion collapseAll className='border-0'>


                            {content.accordionData.map((v, i) => <Accordion.Panel key={i}>
                                <Accordion.Title>{v.year}</Accordion.Title>
                                <Accordion.Content className='bg-white'>
                                    <ul className="mb-2 text-gray-500 dark:text-gray-400">
                                        {v.events.map(c => <li key={c}>{c}</li>)}
                                    </ul>
                                </Accordion.Content>
                            </Accordion.Panel>)}


                        </Accordion>

                    </div>


                </div>


            </section>

        </>
    )
}

export default AdmissionProcess







class getContent {

    accordionData = [
        {
            year: "2014",
            events: [
                "Revision of Vision, Mission, Objectives",
                "Obtain PYP authorisation",
                "Academic resource development",
                "Introduction of MYP: The Next Chapter",
                "Upgrade technology for MYP e-Assessments",
                "Feasibility study of offering IGCSE and MYP as two separate systems"
            ]
        },
        {
            year: "2015",
            events: [
                "Academic resource development",
                "Commence the process for DP evaluation",
                "Design of accountability for the shared Mission and Objectives",
                "Expansion and relocation of the High School campus",
                "Commence the process for MYP evaluation",
                "One laptop per child policy from PYP 4 to DP 2"
            ]
        },
        {
            year: "2016",
            events: [
                "Academic resource development",
                "MYP/DP evaluation visit",
                "Implementation of the plan for accountability of the shared Mission and Objectives",
                "Launch of MYP eAssessments"
            ]
        },
        {
            year: "2017",
            events: [
                "Academic resource development",
                "Commence the process for PYP evaluation"
            ]
        },
        {
            year: "2018",
            events: [
                "Academic resource development",
                "PYP evaluation visit"
            ]
        },
        {
            year: "2019",
            events: []
        }
    ];



}